import React from 'react'

import bg from '../../Assets/Tour/recordsBg.png'
import logo from '../../Assets/Tour/clients.png'
import logo1 from '../../Assets/Tour/places.png'
import logo2 from '../../Assets/Tour/states.png'
import logo3 from '../../Assets/Tour/review.png'
import { useIntersectionObserver } from '../../Assets/CustomHook/CustomHook'
import CountUp from "react-countup";
const OurRecords = () => {
    const [ref, isVisible] = useIntersectionObserver({
        threshold: 0.1,
        triggerOnce: true,
      });
    return (
        <>
            <div className="my-4 overflow-hidden bg-center px-4 py-10 sm:my-6 sm:px-8 sm:py-12 lg:my-8 lg:px-16 lg:py-14" style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "cover",
            }}>
                <div className="grid grid-cols-2 items-center gap-x-3 gap-y-8 text-[#0E2A46] font-bold sm:gap-x-6 lg:grid-cols-4 lg:gap-5" ref={ref}>
                    <div className="flex flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-4 sm:text-left" data-aos="fade-up">
                        <img src={logo} alt="" className="h-12 w-12 shrink-0 object-contain sm:h-14 sm:w-14" />
                        <div className="min-w-0">
                            <div className="text-3xl font-bold sm:text-4xl">{isVisible && <CountUp start={0} end={500} duration={5} />}+</div>
                            <div className="text-sm sm:text-base">Satisfied Clients</div>
                        </div>
                    </div>
                    <div className="flex flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-4 sm:text-left" data-aos="fade-down">
                        <img src={logo1} alt="" className="h-12 w-12 shrink-0 object-contain sm:h-14 sm:w-14" />
                        <div className="min-w-0">
                            <div className="text-3xl font-bold sm:text-4xl">{isVisible && <CountUp start={0} end={1000} duration={5} />}+</div>
                            <div className="text-sm sm:text-base">Places Visited</div>
                        </div>
                    </div>
                    <div className="flex flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-4 sm:text-left" data-aos="fade-right">
                        <img src={logo2} alt="" className="h-12 w-12 shrink-0 object-contain sm:h-14 sm:w-14" />
                        <div className="min-w-0">
                            <div className="text-3xl font-bold sm:text-4xl">{isVisible && <CountUp start={0} end={15} duration={5} />}+</div>
                            <div className="text-sm sm:text-base">States Visited</div>
                        </div>
                    </div>
                    <div className="flex flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-4 sm:text-left" data-aos="fade-left">
                        <img src={logo3} alt="" className="h-12 w-12 shrink-0 object-contain sm:h-14 sm:w-14" />
                        <div className="min-w-0">
                            <div className="text-3xl font-bold sm:text-4xl">{isVisible && <CountUp start={0} end={100} duration={5} />}%</div>
                            <div className="text-sm sm:text-base">Positive Reviews</div>
                        </div>
                    </div>
                </div>
            </div>

         
        </>
    )
}

export default OurRecords
